import { createFileRoute } from '@tanstack/react-router';
import EvidenceListPage from '@/pages/(protected)/workspaces/[workspaceId]/evidence/list';

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/evidence/')({
  component: EvidenceListPage,
  // beforeLoad: ({ params }) => {
  //   throw redirect({
  //     to: '/workspaces/$workspaceId/compliance/tasks',
  //     params: { workspaceId: params.workspaceId },
  //   });
  // },
});
